import { api } from "../api";

const SID_KEY = "haas_sid";

export const getSessionId = () => {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

export const trackEvent = (type, path) => {
  try {
    api
      .track({
        type,
        path: path || window.location.pathname,
        referrer: document.referrer || "",
        session_id: getSessionId(),
      })
      .catch(() => {});
  } catch (e) {
    /* non-blocking */
  }
};
